import React from 'react';
export const IconLoading = () => {
  return (
    <div>
      <img src={'/assets/icons/giphy.webp'} alt="iconLoading" />
    </div>
  );
};
